module.exports = __webpack_public_path__ + "img/room-24-px-3.0d38ab06.svg";